import { useState, useEffect } from "react";
import { useGlobalContext } from "../data/GlobalContext";
import { usePromotionsData } from "../data/PromotionData";
import { useNavigate } from "react-router-dom";
import { initialStages } from "./games/jili-data";
import ModulesLotteryDraw from "../promotions/promotion_modules/modules_lotterDraw";
import ModulePeraBayong from "../promotions/promotion_modules/modules_peraBayong";
import CountdownTimer from "../data/CountdownTimer";
import UserManual from "../UserManual";
import LoginToPlay from "../data/LoginToPlay";
const promoURL = process.env.REACT_APP_API_JSON_URL_PROMO;

export default function SideContainer() {
	const navigate = useNavigate();
	const [lotteryNumbers, setLotteryNumbers] = useState(null);
	const [isUserManual, setUserManual] = useState(false);

	const [activeModal, setActiveModal] = useState(null);
	const { showMysteryFridayBtn, username, isLoggedIn } = useGlobalContext();
	const [login, setLogin] = useState(false);
	const [jiliTurnoverData, setJiliTurnoverData] = useState({});
	const { promotionsData } = usePromotionsData();

	const handleOpenJiliQuest = () => {
		if (!isLoggedIn) {
			setLogin(true);
			return;
		}

		navigate("/promotion?open=jili-quest");
	};

	const highlightPromotion = promotionsData
		.filter((promotion) => promotion.highlightPromotion)
		.sort((a, b) => a.priority - b.priority);

	useEffect(() => {
		if (!username) {
			return;
		}

		const fetchJiliQuest = async () => {
			try {
				const response = await fetch(
					`${promoURL}?cmd=jiliQuest&u=${encodeURIComponent(username)}`,
				);

				const data = await response.json();

				const normalizedData = Object.fromEntries(
					Object.entries(data ?? {}).map(([key, value]) => [
						key,
						Number(value) || 0,
					]),
				);

				setJiliTurnoverData(normalizedData);
			} catch (error) {
				console.error("[JILI Quest] SideContainer turnover error:", error);
			}
		};

		fetchJiliQuest();

		const interval = setInterval(fetchJiliQuest, 15000);

		return () => {
			clearInterval(interval);
		};
	}, [username]);

	useEffect(() => {
		document.body.style.overflow = activeModal ? "hidden" : "auto";
		return () => {
			document.body.style.overflow = "auto";
		};
	}, [activeModal]);

	//       // Only update state if there's a valid drawId.
	//       if (data.drawId !== "") {
	//         setLotteryNumbers(data)
	//       }
	//     } catch (error) {
	//       console.error("Error fetching lottery entries:", error)
	//     }
	//   }

	//   getLotteryEntries()
	// }, [])

	const modalComponents = {
		"2/30 Lottery Draw": ModulesLotteryDraw,
		"Pera O Bayong": ModulePeraBayong,
	};
	const ActiveModal = activeModal ? modalComponents[activeModal] : null;

	// const isPeraOBayongActive = () => {
	//   const now = new Date()
	//   const day = now.getDay() // Sunday = 0, Monday = 1, ..., Saturday = 6
	//   const hours = now.getHours()
	//   const minutes = now.getMinutes()

	//   if (day === 4 && hours >= 16) {
	//     // Thursday after 4:00 PM
	//     return true
	//   } else if (day === 5) {
	//     // Any time on Friday until 11:59 PM
	//     return true
	//   }
	//   return false
	// }

	const showLogin = () => {
		setLogin(true);
	};

	const getTurnoverKey = (stageId) => {
		const week = Math.ceil(stageId / 5);
		const stageIndex = (stageId - 1) % 5;

		const letter = String.fromCharCode(97 + stageIndex);

		return `week${week}${letter}`;
	};

	const stagesWithProgress = initialStages.map((stage) => {
		const turnoverKey = getTurnoverKey(stage.id);

		const currentTurnover = jiliTurnoverData[turnoverKey] ?? 0;

		return {
			...stage,
			currentTurnover,
			completed: currentTurnover >= stage.requiredTurnover,
		};
	});

	const currentStage =
		stagesWithProgress.find((stage) => !stage.completed) ||
		stagesWithProgress[stagesWithProgress.length - 1];
	return (
		<>
			{ActiveModal && <ActiveModal closeModal={() => setActiveModal(null)} />}
			{login && <LoginToPlay onClose={() => setLogin(false)} />}
			<div className="side-bar-container">
				{highlightPromotion.map((promotion) => (
					<div key={promotion.id} className="fgh-featured-promotion-wrapper">
						<div className="fgh-featured-promotion-item">
							<div className="fgh-featured-promotion-box">
								{/* <div className="fgh-snow-melting">
                  <img src="/images/icon/SNOW-MELTING.webp" alt="" />
                </div> */}
								<img
									src={promotion.featuredImg}
									alt={promotion.title}
									className="fgh-featured-promotion-img"
								/>
							</div>
							<p className="featured-promotion-status">
								{promotion.subHeading}
							</p>
							<div className="featured-promotion-details">
								<div className="featured-promotion-countdown">
									<CountdownTimer {...promotion} />

									{promotion.title === "Pera O Bayong" && (
										<div className="lottery-draw-results-container">
											<p>Choose Fortune</p>
											{isLoggedIn ? (
												showMysteryFridayBtn ? (
													<button
														onClick={() => setActiveModal(promotion.title)}
														style={{
															paddingInline: "20px",
															width: "fit-content",
														}}
													>
														Claim Prize
													</button>
												) : (
													<a
														href="/profile#wallet"
														style={{
															paddingInline: "20px",
															width: "fit-content",
														}}
													>
														Claim Prize
													</a>
												)
											) : (
												<button
													onClick={showLogin}
													style={{
														paddingInline: "20px",
														width: "fit-content",
													}}
												>
													Claim Prize
												</button>
											)}
										</div>
									)}
									{promotion.title === "CQ9 Funalo" && (
										<div className="lottery-draw-results-container">
											<p>Funalo Sa Pasko</p>
											{isLoggedIn ? (
												<button
													onClick={() => setActiveModal(promotion.title)}
													style={{
														paddingInline: "20px",
														width: "fit-content",
													}}
												>
													Leaderboard
												</button>
											) : (
												<button
													onClick={showLogin}
													style={{
														paddingInline: "20px",
														width: "fit-content",
													}}
												>
													Leaderboard
												</button>
											)}
										</div>
									)}
									{promotion.title === "2/30 Lottery Draw" && (
										<div className="lottery-draw-results-container">
											<p>
												Winning #{" "}
												{lotteryNumbers && lotteryNumbers.drawId !== "" && (
													<span>
														{lotteryNumbers.number1} : {lotteryNumbers.number2}
													</span>
												)}
											</p>
											{isLoggedIn ? (
												<button onClick={() => setActiveModal(promotion.title)}>
													Guess now
												</button>
											) : (
												<button onClick={showLogin}>Guess now</button>
											)}
										</div>
									)}
								</div>
								{/* Show lottery results container only for promotion with id 4 */}
							</div>
						</div>
						<div className="featured-promotion-info">
							<a
								href={promotion.tncLink}
								className="fgh-featured-promotion-btn"
							>
								<p>{promotion.title}</p>
							</a>
						</div>
					</div>
				))}
			</div>
			{isLoggedIn && (
				<div className="fgh-user-manual-icon">
					<img
						src={currentStage?.logo || "/images/icon/FGH-INFO.webp"}
						alt={currentStage?.gameName || "Open JILI Quest"}
						onClick={handleOpenJiliQuest}
					/>
				</div>
			)}
		</>
	);
}
